import ErrorBoundary from '@components/layout/error-boundary.tsx';
import { queryClient } from '@utils/api/react-query-instance.ts';
import i18n from '@utils/i18n.ts';
import { AuthContextProvider } from '@utils/providers/auth-context.tsx';
import { ConfirmProvider } from '@utils/providers/confirm-context.tsx';
import EntitlementsProvider from '@utils/providers/entitlements-context.tsx';
import ThemeProvider, {
  useThemeContext
} from '@utils/providers/theme-context.tsx';
import { MotionConfig } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import Router from './router/router.tsx';
import { UnsavedChangesProvider } from '@utils/providers/unsaved-changes-context.tsx';

function ThemedToaster() {
  const { getColour } = useThemeContext();

  return (
    <Toaster
      position="top-right"
      containerClassName="toast-container"
      containerStyle={{
        zIndex: 11000
      }}
      toastOptions={{
        duration: 4000,
        style: {
          maxWidth: '500px',
          background: getColour('secondLayer'),
          color: getColour('normalText'),
          border: `1px solid ${getColour('hairline')}`,
          borderRadius: '0.75rem'
        },
        success: {
          iconTheme: {
            primary: getColour('success'),
            secondary: getColour('baseLayer')
          }
        },
        error: {
          iconTheme: {
            primary: getColour('danger'),
            secondary: getColour('baseLayer')
          }
        },
        loading: {
          iconTheme: {
            primary: getColour('activeText'),
            secondary: getColour('baseLayer')
          }
        }
      }}
    />
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <EntitlementsProvider>
          <I18nextProvider i18n={i18n}>
            <ThemeProvider>
              <MotionConfig reducedMotion="user">
                <UnsavedChangesProvider>
                  <ConfirmProvider>
                    <ErrorBoundary>
                      <Router />
                    </ErrorBoundary>

                    <ThemedToaster />
                  </ConfirmProvider>
                </UnsavedChangesProvider>
              </MotionConfig>
            </ThemeProvider>
          </I18nextProvider>
        </EntitlementsProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  );
}
